import { Col, Row } from 'antd';
import React from 'react';
import PanelContentHeader from '@portal/components/PanelContentHeader/PanelContentHeader';
import { translate } from '@portal/services/i18n';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import GroupUser from '@portal/assets/svg/group_user.svg?react';
import Folder from '@portal/assets/svg/folder.svg?react';
import UserSingle from '@portal/assets/svg/user_single.svg?react';
import { getRouteStackPath } from '@portal/config/routes';
import { useNavigation } from '@portal/hooks/useNavigation';

interface IMenuProps {
  text: string;
  startIcon: JSX.Element;
  onClick?: () => void;
}

const MenuButtom: React.FC<IMenuProps> = ({ text, startIcon, onClick }) => {
  return (
    <Row>
      <AdvancedButton
        startIcon={startIcon}
        customStyles={{ width: 300, justifyContent: 'start' }}
        text={text}
        onClick={onClick}
      />
    </Row>
  );
};

const UserManagerMenus = () => {
  const navigate = useNavigation();

  return (
    <div>
      <Col className="menu-manager">
        <div className="menu-manager__container-left">
          <PanelContentHeader pageTitle="Internet Banking" />

          <p className="menu-manager__container-left__subtitle">
            {translate('PAGES.USER_MANAGER.TITLE')}
          </p>
          <hr />
        </div>

        <Row>
          <Col className="menu-manager__col-container">
            <div style={{ flexDirection: 'row', marginBottom: 41 }}>
              <GroupUser className="menu-manager__container-actions__icon" />

              <span className="menu-manager__container-actions__col-title">
                {translate('PAGES.USER_MANAGER.COL_1_TITLE')}
              </span>
            </div>

            <div className="menu-manager__container-actions">
              <MenuButtom
                onClick={() =>
                  navigate(getRouteStackPath('USER_MANAGER', 'USER_LIST'))
                }
                startIcon={<GroupUser style={{ marginLeft: '-15px' }} />}
                text={translate('PAGES.USER_MANAGER.BUTTONS.USERS')}
              />

              <MenuButtom
                onClick={() =>
                  navigate(getRouteStackPath('PROFILE_MANAGER', 'PROFILE_LIST'))
                }
                startIcon={<GroupUser style={{ marginLeft: '-15px' }} />}
                text={translate('PAGES.USER_MANAGER.BUTTONS.PROFILES')}
              />

              <MenuButtom
                startIcon={<GroupUser style={{ marginLeft: '-15px' }} />}
                text={translate('PAGES.USER_MANAGER.BUTTONS.REPORT')}
              />
            </div>
          </Col>
          <Col>
            <div style={{ flexDirection: 'row', marginBottom: 41 }}>
              <Folder className="menu-manager__container-actions__icon" />

              <span className="menu-manager__container-actions__col-title">
                {translate('PAGES.USER_MANAGER.COL_2_TITLE')}
              </span>
            </div>

            <div className="menu-manager__container-actions">
              <MenuButtom
                startIcon={<UserSingle style={{ marginLeft: '-15px' }} />}
                text={translate('PAGES.USER_MANAGER.BUTTONS.REPRESENT_LEGAL')}
              />

              <MenuButtom
                startIcon={<UserSingle style={{ marginLeft: '-15px' }} />}
                text={translate('PAGES.USER_MANAGER.BUTTONS.SEARCH')}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default UserManagerMenus;
